<script>
import 'bulma/css/bulma.css'
import modalWindow from '@/components/ModalWindow'
import Mentionable from '@/components//Mentionable'
import { countCharacters, formatDate, removeUrl, removeHtml, getMentionableFormat, getMentionedUsers, addMentionHighlight } from '@/api/Utilities.js'
import { addNode, addNodesbyCard } from '@/api/FirebaseTreesWrapper.js'
require('@/css/style.css')

export default {
  components: {
    modalWindow,
    Mentionable
  },
  props: [
    'nodeId',
    'addQuestionFlag',
    'loginUserId', // Treeを見ているユーザーのID
    'treeId',
    'nodesNum',
    'members',
    'team',
    'boardCardData'
  ],
  data () {
    return {
      Q_LENGTH: 1000,
      nextQuestionMsgLength: 0,
      nextQuestionMsg: '',
      tempQuestionMap: new Map(),
      alertNextQuestionMsg: '', // 入力した質問がルール違反の際の警告文章
      users: [], // @mention時に表示するuserlist
      isDuringPost: false, // 重複Post防止用にpostStateを保持
      enableCardBtn: false,
      selectedCardData: [],
      enableSelectedCards: false,
      composing: false // 日本語変換処理中はTrue
    }
  },
  async created () {
    this.selectedCardData = []
    this.nextQuestionMsg = ''
    this.users = getMentionableFormat(this.members)
  },
  mounted () {
  },
  computed: {
    rows: function () {
      if (!this.nextQuestionMsg) { return 1 }
      const num = this.nextQuestionMsg.split('\n').length
      return (num < 6) ? num : 6
    }
  },
  watch: {
    nextQuestionMsg: function (val) {
      this.nextQuestionMsgLength = countCharacters(this.nextQuestionMsg)
      this.tempQuestionMap.set(this.nodeId, this.nextQuestionMsg)
      this.$emit('updatingText', this.nextQuestionMsg)
    },
    nodeId: function (val) {
      this.nextQuestionMsg = this.tempQuestionMap.get(this.nodeId)
    },
    addQuestionFlag: function (val) {
      if (this.addQuestionFlag && !this.enableSelectedCards) {
        this.$nextTick(() => this.$refs.QuestionTextInput.focus())
      }
    }
  },
  methods: {
    async postQuestion () {
      // 重複ポストならreturn
      if (this.isDuringPost) { return }
      // 日本語変換中ならreturn
      if (this.composing) { return }
      this.alertNextQuestionMsg = ''
      // 重複ポスト用Flagを立てる
      this.isDuringPost = true
      if (!this.nextQuestionMsg) {
        this.alertNextQuestionMsg = '文字を入力してください'
        this.isDuringPost = false
        return
      }
      if (this.nextQuestionMsgLength > this.Q_LENGTH) {
        this.alertNextQuestionMsg = '指定文字数を超えています'
        this.isDuringPost = false
        return
      }
      // mentionされたUserを算出
      const mentionedUsers = getMentionedUsers(this.nextQuestionMsg, this.users)

      // mentionにhighlightの追加
      const highlightMsg = addMentionHighlight(this.nextQuestionMsg, this.users)
      try {
        this.tempQuestionMap.delete(this.nodeId)
        const nodeRef = await addNode(this.treeId, highlightMsg, this.nodeId, 'soso', mentionedUsers, null)
        this.nextQuestionMsg = ''
        this.isDuringPost = false
        return nodeRef
      } catch (err) {
        this.alertNextQuestionMsg = 'error'
        this.isDuringPost = false
        console.error(err)
      }
    },
    async postCards () {
      // 重複ポスト用Flagを立てる
      this.isDuringPost = true

      if (this.selectedCardData.length === 0) {
        this.alertNextQuestionMsg = '選択されたカードがありません'
        return
      }
      // cardの数だけloop処理
      await addNodesbyCard(this.treeId, this.nodeId, this.team, this.selectedCardData)

      this.isDuringPost = false
      this.enableCardBtn = false
      this.enableSelectedCards = false
      this.selectedCardData = []
      this.$emit('updatingText', '')
    },
    async keyDownCtrlEnter () {
      await this.postQuestion()
    },
    closeAnonymousModal () {
      this.isAnonymousModal = false
    },
    mentionUsers (item, key) {
      // console.log(item)
    },
    isFocus () {
      // focusされたらgraph.vueでtempNodeを出す
      this.$emit('focusingTextarea', this.nodeId)
    },
    isBlur () {
      // focusが外されたらリセット
      this.$emit('focusingTextarea', '')
    },
    clickCardBtn () {
      this.enableCardBtn = !this.enableCardBtn
    },
    closeCardModal () {
      this.enableCardBtn = false
      this.enableSelectedCards = false
      this.selectedCardData = []
    },
    reduceMessage (message) {
      let msg = removeUrl(message)
      msg = removeHtml(msg)
      if (!msg) { return }
      if (msg.length > 50) {
        msg = msg.substr(0, 50) + '...'
      }
      return msg
    },
    selectCard (data) {
      const targetIndex = this.selectedCardData.findIndex(({id}) => id === data.id)
      if (targetIndex !== -1) {
        this.selectedCardData.splice(targetIndex, 1)
      } else {
        this.selectedCardData.push(data)
        this.enableCardBtn = false
        this.enableSelectedCards = true
        this.$emit('focusingTextarea', this.nodeId)
        this.$emit('updatingText', this.selectedCardData[0].question)
        this.$nextTick(() => this.$refs.SelectCardInput.focus())
      }
    },
    isSelectedCard (cardId) {
      const targetIndex = this.selectedCardData.findIndex(({id}) => id === cardId)
      if (targetIndex !== -1) {
        return true
      } else {
        return false
      }
    },
    isCardColor (data, marker) {
      if (data === marker) {
        return true
      } else {
        return false
      }
    },
    clickDeleteCard (cardId) {
      const targetIndex = this.selectedCardData.findIndex(({id}) => id === cardId)
      if (targetIndex !== -1) {
        this.selectedCardData.splice(targetIndex, 1)
      }
      if (this.selectedCardData.length === 0) {
        this.enableCardBtn = false
        this.enableSelectedCards = false
        this.$emit('updatingText', '')
      }
    },
    compositionStart () {
      this.composing = true
    },
    compositionEnd () {
      this.composing = false
    }
  },
  filters: {
    timestampToDate: function (firebaseTimestamp) {
      if (!firebaseTimestamp || firebaseTimestamp.hasOwnProperty('toDate')) {
        return
      }
      return formatDate(firebaseTimestamp.toDate(), 'MM/dd HH:mm')
    }
  }
}

</script>
<style scoped>
.comments{
  background-color: #fcfcfc;
  border: 1px solid rgba(200, 200, 200, 0.5);
}
.column {
  padding-bottom: 0;
}
.add-paddingleft {
  padding-left: 0.75rem;
}
.add-paddingright {
  padding-right: 0.75rem;
}
.buttons:last-child {
  margin-bottom: 0rem;
}
.progress {
  margin-top: 2px;
  background-color: #dbdbdb;
}
.field {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
@media screen and (max-width: 700px) {
  .dropdown {
    background-color: white;
    border-radius: 6px;
    box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1);
    font-size: 0.875rem;
    position:absolute;
    max-width: 80%;
    min-width: 60%;
    max-height: 70%;
    min-height: 40%;
    z-index: 50;
    transition: min-height 0.5s;
    font-size: 0.6rem;
  }
}
@media screen and (min-width: 701px) {
  .dropdown {
    background-color: white;
    border-radius: 6px;
    box-shadow: 0 8px 8px rgba(10, 10, 10, 0.1);
    font-size: 0.875rem;
    position:absolute;
    max-width: 50%;
    min-width: 40%;
    max-height: 60%;
    min-height: 40%;
    z-index: 50;
    transition: min-height 0.5s;
    font-size: 0.8rem;
  }
}
.card-item {
  overflow: auto;
  width: 100%;
  max-height: 80%;
}
.card-data {
  padding: 0.75rem;
  border-bottom: solid 1px;
  border-bottom-color: #bbbbbb;
  cursor:pointer
}
.card-data:hover{
  background-color:#eeeeee;
}
.is-selected {
  background-color: #f0f8ff;
}
.card-select {
  padding: 0.5rem;
  background: white;
  border-end-end-radius: 6px;
  border-end-start-radius: 6px;
  position: absolute;
  width: 100%;
  top: 99%;
}
.card-icon {
  margin: 0.3rem;
}
.card-content {
  padding: 0.5rem;
  margin: 0.35rem;
  font-size: 0.8rem;
  border-radius: 3px;
  cursor:pointer
}
.data-icon {
  display: flex;
  justify-content: space-between;
}
.is-yellow {
  background-color: hsl(60deg 100% 85%);
}
.is-red {
 background-color: #f5e1e6;
}
.is-green {
  background-color: hsl(100deg 100% 85%);
}

</style>
<template>
  <div class="comments">
    <div class="post">
      <div class="field">
        <!-- テキストエリアを表示 -->
        <div class="control has-text-left" v-if="!enableCardBtn && !enableSelectedCards">
          <Mentionable :keys="['@', '＠']" :items="users" @apply="mentionUsers" insert-space omit-key>
            <textarea v-if="nextQuestionMsgLength<=Q_LENGTH" class="textarea" ref="QuestionTextInput" placeholder="メモやメッセージを書く" v-model="nextQuestionMsg" :rows="rows" @keydown.ctrl.enter="keyDownCtrlEnter()" @keydown.meta.enter="keyDownCtrlEnter()" @focus="isFocus()" @blur="isBlur()" @compositionstart.prevent="compositionStart()" @compositionend.prevent="compositionEnd()"></textarea>
            <textarea v-else class="textarea is-danger" ref="QuestionTextInput" placeholder="メモやメッセージを書く" v-model="nextQuestionMsg" :rows="rows" @keydown.ctrl.enter="keyDownCtrlEnter()" @keydown.meta.enter="keyDownCtrlEnter()" @focus="isFocus()" @blur="isBlur()" @compositionstart.prevent="compositionStart()" @compositionend.prevent="compositionEnd()"></textarea>
            <template #item="{ item }">
              <div class="user">
                <span class="font-weight-bold">
                  {{ item.value }}
                </span>
              </div>
            </template>
          </Mentionable>
        </div>
        <!-- 選択されたカードアイコンを表示 -->
        <div class="card-icon" v-else>
          <div class="card-content has-text-left" v-for="(data, index) in selectedCardData" :key="index"
          v-bind:class="{'is-yellow':isCardColor(data.marker, 'soso'), 'is-red':isCardColor(data.marker, 'thinking'), 'is-green':isCardColor(data.marker, 'important')}">
            <div class="data-icon">
              <div>{{reduceMessage(data.question)}}</div>
              <button class="delete is-small" @click="clickDeleteCard(data.id)"></button>
            </div>
          </div>
        </div>
      </div>
      <div class="state">
        <div class="columns is-mobile is-marginless">
          <!-- カード選択ボタン -->
          <div class="column is-one-quaters is-paddingless">
            <div class="field add-paddingleft">
              <div class="control has-text-left">
                <button class="button is-small" @click="clickCardBtn()">
                  <i class="fa-solid fa-clipboard-check" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <!-- カード選択の表示 -->
            <div class="overlay" v-if="enableCardBtn">
              <div class="dropdown">
                <div class="card-item">
                  <div class="card-data has-text-left" v-for="(data, index) in boardCardData" :key="index"
                  v-bind:class="{'is-selected' :isSelectedCard(data.id)}" @click="selectCard(data)">
                    <div class="data">
                      <!-- カラーアイコン -->
                      <span class="text has-text-success" v-if="data.marker==='important'">
                        <i class="fa-solid fa-square" v-if="!isSelectedCard(data.id)"></i>
                        <i class="fa-solid fa-lg fa-square-check" v-else></i>
                      </span>
                      <span class="text has-text-danger" v-else-if="data.marker==='thinking'">
                        <i class="fa-solid fa-square" v-if="!isSelectedCard(data.id)"></i>
                        <i class="fa-solid fa-lg fa-square-check" v-else></i>
                      </span>
                      <span class="text has-text-warning" v-else>
                        <i class="fa-solid fa-square" v-if="!isSelectedCard(data.id)"></i>
                        <i class="fa-solid fa-lg fa-square-check" v-else></i>
                      </span>
                      <!-- テキスト -->
                      {{reduceMessage(data.question)}}
                    </div>
                  </div>
                  <div class="card-select">
                    <div class="buttons has-addons is-right">
                      <button class="button is-small" @click="closeCardModal">キャンセル</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-one-quarters is-paddingless" v-if="!enableSelectedCards">
            <progress class="progress is-small" :value="nextQuestionMsgLength" :max="Q_LENGTH"></progress>
          </div>
          <div class="column is-one-quarters is-paddingless is-size-7">
            <span v-if="!enableSelectedCards">
              残り{{Q_LENGTH-nextQuestionMsgLength}}
            </span>
            <span v-else>
              カード選択数：{{selectedCardData.length}}
            </span>
          </div>
          <div class="column is-paddingless">
            <div class="field add-paddingright">
              <!-- text入力のPost -->
              <div class="control has-text-right" @click="postQuestion();" v-if="!enableSelectedCards">
                <button class="button is-small is-link" v-if="nextQuestionMsgLength !==0 && nextQuestionMsgLength <= Q_LENGTH">
                  <i class="fa-solid fa-paper-plane" aria-hidden="true"></i>
                </button>
                <button class="button is-small" v-else>
                  <i class="fa-solid fa-paper-plane" aria-hidden="true"></i>
                </button>
              </div>
              <!-- CardsのPost -->
              <div class="control has-text-right" @click="postCards()" v-else>
                <button class="button is-small is-link" @keydown.ctrl.enter="postCards()" @keydown.meta.enter="postCards()" ref="SelectCardInput">
                  <i class="fa-solid fa-paper-plane" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="help is-danger">{{alertNextQuestionMsg}}</p>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/tree/postCard.vue